/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-self-assign */
/* eslint-disable radix */
/* eslint-disable react/button-has-type */
/* eslint-disable no-plusplus */
/* eslint-disable no-else-return */
/* eslint-disable no-lonely-if */
/* eslint-disable no-loop-func */
/* eslint-disable import/no-cycle */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable eqeqeq */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-use-before-define */
/* eslint-disable indent */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-inner-declarations */

export default function TraceSourceNode(id, nodes, edges) {

  function findAllPath(connectionData, stream_num_dict, roCount) {
    // JavaScript program to print all paths from a source to destination.
    let v;
    let adjList;

    // A directed graph using adjacency list representation
    function Graph(vertices) {
      // initialise vertex count
      v = vertices;
      // initialise adjacency list
      initAdjList();
    }
    // utility method to initialise
    // adjacency list
    function initAdjList() {
      adjList = new Array(v);
      for (let i = 0; i < v; i++) {
        adjList[i] = [];
      }
    }
    // add edge from u to v
    function addEdge(u, v) {
      // Add v to u's list.
      if (!adjList[u]) {
        adjList[u] = [];
      }
      adjList[u].push(v);
    }
    // Prints all paths from
    // 's' to 'd'
    function printAllPaths(s, d) {
      const isVisited = new Array(v);
      for (let i = 0; i < v; i++)
        isVisited[i] = false;
      const pathList = [];
      // add source to path[]
      pathList.push(s);
      // Call recursive utility
      printAllPathsUtil(s, d, isVisited, pathList);
    }

    function printAllPathsUtil(u, d, isVisited, localPathList) {
      if (u == (d)) {
        localStorage.setItem('localpath', localPathList);
        // if match found then no need to traverse more till depth
        return;
      }
      // Validate that adjList[u] exists and is an array
      if (!adjList[u] || !Array.isArray(adjList[u])) {
        return;
      }
      // Mark the current node
      isVisited[u] = true;
      // Recur for all the vertices
      // adjacent to current vertex
      for (let i = 0; i < adjList[u].length; i++) {
        if (!isVisited[adjList[u][i]]) {
          // store current node in path[]
          localPathList.push(adjList[u][i]);
          printAllPathsUtil(adjList[u][i], d,
            isVisited, localPathList);
          // remove current node in path[]
          localPathList.splice(localPathList.indexOf
            (adjList[u][i]), 1);

        }
      }
      // Mark the current node
      isVisited[u] = false;
    }

    const edge_dict = {};
    const unitopList = Object.keys(connectionData.unit_op_dict_final.unit_op_dict);
    unitopList.forEach((item, index) => {
      edge_dict[item] = index;
    });
    Graph(Object.values(connectionData.stream_input_dict_final.stream_input_dict).length + 1);
    Object.values(connectionData.stream_input_dict_final.stream_input_dict).forEach((item) => {
      addEdge(edge_dict[Object.values(item)[0]], edge_dict[Object.values(item)[1]]);

    });

    const s = edge_dict[roCount[0]];
    // arbitrary destination
    const d = edge_dict[roCount[roCount.length - 1]];
    if (s === undefined && d === undefined) {
      return;
    }
    printAllPaths(s, d);
    let path = localStorage.getItem('localpath');

    if (path == null) {
      if (roCount.length > 0);
      return;
    }
    path = path.split(',');
    const path1 = Object.keys(edge_dict).find(key => edge_dict[key] === parseInt(path[0]));
    const path2 = Object.keys(edge_dict).find(key => edge_dict[key] === parseInt(path[1]));
    localStorage.removeItem('localpath');

    const flow_sheet_dict = {};

    if (roCount.length >= 2) {
      Object.values(stream_num_dict).filter(
        (item, index) => {
          if (item.source == path1 && item.destination == path2) {
            const streamNum = Number(Object.keys(stream_num_dict)[index]);
            if (connectionData.unit_op_dict_final.unit_op_dict[path1].Product.includes(streamNum)) {
              flow_sheet_dict.Type = `${roCount.length} Pass`;
            }
            else if (connectionData.unit_op_dict_final.unit_op_dict[path1].Waste.includes(streamNum)) {
              flow_sheet_dict.Type = 'Brine Staged';
            }
          }
        }
      );
    }
    else {
      flow_sheet_dict.Type = '1 Pass';
    }
    // added by chandrashekhar 13-sep-2023 return flow_sheet_dict
    return flow_sheet_dict;
  }
  const unitOpName = {};
  const unitOpID = [];
  const unitOpType = {};
  const stream_input_dict = {};
  const unit_op_dict = {};
  const outgoing_connection = [];
  const incoming_connection = [];
  const unitOpDetails_FeedStream = {};
  const unitOpDetails_ROWasteStream = {};
  const unitOpDetails_WasteStream = {};
  const unitOpDetails_SplitStream = {};
  const unitOpDetails_ProductStream = {};
  const unitOpDetails_ElectrodeStream = {};
  const unitOpDetails_ConcStream = {};
  // Example: reactflow__edge-roPump_1c-mixsplit_1a
  const parts = id.replace('reactflow__edge-', '').split('-');
  if (parts.length === 2) {
    const [src, tgt] = parts;

    // Only log if source is a roPump with "c"
    if ((src.startsWith('roPump') && src.endsWith('c')) || (src.startsWith('nfPump') && src.endsWith('c')) || (src.startsWith('roPump') && src.endsWith('d'))) {
      //   const nodes = getNodes();
      //   const edges = getEdges();
      const elements = [...nodes, ...edges];
      const elements_sorted = [];
      let ediOutputData = [];
      for (let i = 0; i < elements.length; i += 1) {
        if (elements[i].id && elements[i].id.length < 19) {
          elements_sorted.push(elements[i]);
        }
      }
      for (let i = 0; i < elements.length; i += 1) {
        if (elements[i].source) {
          elements_sorted.push(elements[i]);
        }
      }
      // GB-2259 chandrashekhar kumar added.
      ediOutputData = elements_sorted.filter((ele) => {
        // get the all edi unitop whose type of customnode_edi.
        return ele.type === 'customnode_edi';
      });
      if (ediOutputData.length && ediOutputData[0].id) {
        const data = [];
        for (let k = 0; k < ediOutputData.length; k += 1) {
          data.push(elements_sorted.filter((ele) => {
            // get the all edi unitop whose source handle is 'c' (outgoing) and source and id is same.
            return ele.source === ediOutputData[k].id && ele.sourceHandle === 'c';
          }));
        }
        ediOutputData = data.flat(Infinity);
      }
      const EDIConnection = {};
      const EDIFormData = {};
      for (let i = 0; i < elements_sorted.length; i += 1) {
        if (elements_sorted[i].id && elements_sorted[i].id.length < 19) {
          unitOpName[elements_sorted[i].id] = localStorage.getItem(elements_sorted[i].id);
          unitOpID.push(elements_sorted[i].id);
          const elementsSortedName = (elements_sorted[i].id).replace(/[\d_]+/g, '');
          if (elementsSortedName === 'stripper')
            unitOpType[elements_sorted[i].id] = 'Stripper';
          if (elementsSortedName === 'product')
            unitOpType[elements_sorted[i].id] = 'ProductOut';
          if (elementsSortedName === 'feed')
            unitOpType[elements_sorted[i].id] = 'Feed';
          if (elementsSortedName === 'ro')
            unitOpType[elements_sorted[i].id] = 'RO';
          if (elementsSortedName === 'nf')
            unitOpType[elements_sorted[i].id] = 'NF';
          if (elementsSortedName === 'nfPump') {
            unitOpType[elements_sorted[i].id] = 'NF_HP';
          }
          if (elementsSortedName === 'roPump') {
            if (elements_sorted[i].type === 'customnode_CLROpump') {
              unitOpType[elements_sorted[i].id] = 'CLRO';
            }
            else {
              unitOpType[elements_sorted[i].id] = 'RO_HP';
            }
          }
          if (elementsSortedName === 'hppump')
            unitOpType[elements_sorted[i].id] = 'HP_Pump';
          if (elementsSortedName === 'edi')
            unitOpType[elements_sorted[i].id] = 'EDI';
          if ((elements[i].id).replace(/[\d_]+/g, '') === 'pump')
            unitOpType[elements_sorted[i].id] = 'Pump';
          if (elementsSortedName === 'mixsplit')
            unitOpType[elements_sorted[i].id] = 'Mixer_Splitter';
          if (elementsSortedName === 'wasteout')
            unitOpType[elements_sorted[i].id] = 'Waste';
          if (elementsSortedName === 'cartridge')
            unitOpType[elements_sorted[i].id] = 'Cartridge';
          if (elementsSortedName === 'chemicaldosing')
            unitOpType[elements_sorted[i].id] = 'Chemical_Dosing';
          if (elementsSortedName === 'wex')
            unitOpType[elements_sorted[i].id] = 'ERD';
          if (elementsSortedName === 'peltonwheel')
            unitOpType[elements_sorted[i].id] = 'PW';
          if (elementsSortedName === 'TC')
            unitOpType[elements_sorted[i].id] = 'TC';
          if (elementsSortedName === 'WaterComp')
            unitOpType[elements_sorted[i].id] = 'WaterComp';
          if (elementsSortedName === 'Argo')
            unitOpType[elements_sorted[i].id] = 'Argo';
        }
        if (elements_sorted[i].source && unitOpName[elements_sorted[i].source] && elements_sorted[i].target !== 'undefined') {
          stream_input_dict[elements_sorted[i].data.text] = { 'source': unitOpName[elements_sorted[i].source], 'destination': unitOpName[elements_sorted[i].target] };
          if (elements_sorted[i] && elements_sorted[i].target && elements_sorted[i].target.toUpperCase().indexOf('EDI') >= 0) {
            EDIConnection[elements_sorted[i].data.text] = unitOpName[elements_sorted[i].target];
          }
        }
      }
      // console.log("RO Pump Source:", src);
      // console.log("Connected Target:", tgt);
      // console.log('stream_input_dict', stream_input_dict);
      const stream_input_dict_final = {
        stream_input_dict
      };
      function findDuplicatesByKey(arr, key) {
        // Count occurrences of each value
        const counts = arr.reduce((acc, obj) => {
          acc[obj[key]] = (acc[obj[key]] || 0) + 1;
          return acc;
        }, {});

        // Filter for values that occur more than once
        const duplicates = Object.entries(counts)
          .filter(([, count]) => count > 1)
          .map(([value]) => value);

        return duplicates;
      }

      for (let i = 0; i < unitOpID.length; i += 1) {
        for (let j = 0; j < elements.length; j += 1) {
          // if element is source
          if (unitOpID[i] === elements[j].source) {
            outgoing_connection.push({ 'UnitOp': unitOpID[i], 'Outgoing': elements[j].target, 'stream': elements[j].data.text, 'port': elements[j].sourceHandle });
            // added this code by Akhil to remove duplicate dict from an Array.. ref: 3pass_not_saved.win
            const outgoing_unitop = findDuplicatesByKey(outgoing_connection, 'Outgoing');
            const unitop = findDuplicatesByKey(outgoing_connection, 'UnitOp');
            const streamNo = findDuplicatesByKey(outgoing_connection, 'stream');

            if (outgoing_unitop.length > 0 && unitop.length > 0 && streamNo.length > 0 && outgoing_unitop[0] === elements[j].target && unitop[0] === unitOpID[i] && streamNo[0] === (elements[j].data.text).toString()) {
              outgoing_connection.pop();
            }
          }

          // if element is target
          if (unitOpID[i] === elements[j].target) {
            incoming_connection.push({ 'UnitOp': unitOpID[i], 'Incoming': elements[j].source, 'stream': elements[j].data.text, 'port': elements[j].targetHandle });

            const incoming_unitop = findDuplicatesByKey(incoming_connection, 'Incoming');
            const unitop = findDuplicatesByKey(incoming_connection, 'UnitOp');
            const streamNo = findDuplicatesByKey(incoming_connection, 'stream');

            if (incoming_unitop.length > 0 && unitop.length > 0 && streamNo.length > 0 && incoming_unitop[0] === elements[j].source && unitop[0] === unitOpID[i] && streamNo[0] === (elements[j].data.text).toString()) {
              incoming_connection.pop();
            }

          }
        }
      }
      // ############## testing phase ##############
      for (let j = 0; j < incoming_connection.length; j += 1) {
        if (unitOpID.indexOf(incoming_connection[j].UnitOp) !== -1) {
          // unitOpDetails_FeedStream.push({ 'Unit Type': incoming_connection[j]['UnitOp'], 'Feed Stream': [incoming_connection[j]['stream']] })
          if (!incoming_connection[j].UnitOp.includes('TC') && !incoming_connection[j].UnitOp.includes('wex') && incoming_connection[j].UnitOp in unitOpDetails_FeedStream) {
            unitOpDetails_FeedStream[incoming_connection[j].UnitOp].push(incoming_connection[j].stream);
            unitOpDetails_FeedStream[incoming_connection[j].UnitOp] = unitOpDetails_FeedStream[incoming_connection[j].UnitOp];
          }
          else if (incoming_connection[j].UnitOp.includes('wex')) {
            if (incoming_connection[j].port === 'a_w') {
              // unitOpDetails_FeedStream[incoming_connection[j].UnitOp].push(incoming_connection[j].stream);
              unitOpDetails_FeedStream[incoming_connection[j].UnitOp] = [incoming_connection[j].stream]; // unitOpDetails_FeedStream[incoming_connection[j].UnitOp];
            }
            else {
              unitOpDetails_ROWasteStream[incoming_connection[j].UnitOp] = [incoming_connection[j].stream];
            }

            // unitOpDetails_ROWasteStream[incoming_connection[j].UnitOp].push(incoming_connection[j].stream);
            // unitOpDetails_ROWasteStream[incoming_connection[j].UnitOp] = [incoming_connection[j].stream]; // unitOpDetails_ROWasteStream[incoming_connection[j].UnitOp];
          }
          else if (incoming_connection[j].UnitOp.includes('TC')) {
            if (incoming_connection[j].port === 'a_tc') {
              // unitOpDetails_FeedStream[incoming_connection[j].UnitOp].push(incoming_connection[j].stream);
              unitOpDetails_FeedStream[incoming_connection[j].UnitOp] = [incoming_connection[j].stream]; // unitOpDetails_FeedStream[incoming_connection[j].UnitOp];
            }
            else {
              unitOpDetails_ROWasteStream[incoming_connection[j].UnitOp] = [incoming_connection[j].stream];
            }
            // unitOpDetails_ROWasteStream[incoming_connection[j].UnitOp].push(incoming_connection[j].stream);
            // unitOpDetails_ROWasteStream[incoming_connection[j].UnitOp] = [incoming_connection[j].stream]; // unitOpDetails_ROWasteStream[incoming_connection[j].UnitOp];
          }
          else {
            unitOpDetails_FeedStream[incoming_connection[j].UnitOp] = [incoming_connection[j].stream];
          }
        }
      }
      for (let j = 0; j < outgoing_connection.length; j += 1) {
        if (unitOpID.indexOf(outgoing_connection[j].UnitOp) !== -1) {
          // unitOpDetails_WasteStream.push({ 'Unit Type': outgoing_connection[j]['UnitOp'], 'Waste Stream': [outgoing_connection[j]['stream']] })
          if (outgoing_connection[j].port === 'd' || outgoing_connection[j].port === 'd_w' || outgoing_connection[j].port === 'd_tc') {
            unitOpDetails_WasteStream[outgoing_connection[j].UnitOp] = [outgoing_connection[j].stream];
          }
          if (outgoing_connection[j].port === 'e') {
            // unitOpDetails_WasteStream.push({ 'Unit Type': outgoing_connection[j]['UnitOp'], 'Waste Stream': [outgoing_connection[j]['stream']] })
            unitOpDetails_ElectrodeStream[outgoing_connection[j].UnitOp] = [outgoing_connection[j].stream];
          }
          if (outgoing_connection[j].port === 'f') {
            // unitOpDetails_WasteStream.push({ 'Unit Type': outgoing_connection[j]['UnitOp'], 'Waste Stream': [outgoing_connection[j]['stream']] })
            unitOpDetails_ConcStream[outgoing_connection[j].UnitOp] = [outgoing_connection[j].stream];
          }
          if (outgoing_connection[j].port === 's') {
            // unitOpDetails_WasteStream.push({ 'Unit Type': outgoing_connection[j]['UnitOp'], 'Waste Stream': [outgoing_connection[j]['stream']] })
            unitOpDetails_SplitStream[outgoing_connection[j].UnitOp] = [outgoing_connection[j].stream];
          }
          if (outgoing_connection[j].port === 'c' || outgoing_connection[j].port === 'b_w' || outgoing_connection[j].port === 'b_tc') {
            // unitOpDetails_ProductStream.push({ 'Unit Type': outgoing_connection[j]['UnitOp'], 'Product Stream': [outgoing_connection[j]['stream']] })
            if (outgoing_connection[j].UnitOp in unitOpDetails_ProductStream) {
              // a.push(outgoing_connection[j].stream);
              unitOpDetails_ProductStream[outgoing_connection[j].UnitOp].push(outgoing_connection[j].stream);
              unitOpDetails_ProductStream[outgoing_connection[j].UnitOp] = unitOpDetails_ProductStream[outgoing_connection[j].UnitOp];
            } else {
              unitOpDetails_ProductStream[outgoing_connection[j].UnitOp] = [outgoing_connection[j].stream];
            }
          }
        }
      }
      for (let i = 0; i < unitOpID.length; i += 1) {

        let unitType;
        const unitopIdName = unitOpID[i].replace(/[\d_]+/g, '');
        if (unitopIdName === 'product') {
          unitType = 'ProductOut';
        }
        if (unitopIdName === 'stripper') {
          unitType = 'Stripper';
        } else if (unitopIdName === 'ro') {
          unitType = 'RO';
        } else if (unitopIdName === 'nf') {
          unitType = 'RO';
        } else if (unitopIdName === 'nfPump') {
          unitType = 'RO_HP';
        } else if (unitopIdName === 'feed') {
          unitType = 'Feed';
        } else if (unitopIdName === 'chemicaldosing') {
          unitType = 'Chemical_Dosing';
        } else if (unitopIdName === 'edi') {
          unitType = 'EDI';
        } else if (unitopIdName === 'hppump') {
          unitType = 'HP_Pump';
        } else if (unitopIdName === 'pump') {
          unitType = 'Pump';
        } else if (unitopIdName === 'roPump') {
          elements_sorted.forEach((item) => {
            if (unitOpID[i] === item.id) {
              if (item.type === 'customnode_CLROpump') {
                unitType = 'CLRO';
              } else {
                unitType = 'RO_HP';
              }
            }
          });
        } else if (unitopIdName === 'mixsplit') {
          unitType = 'Mixer_Splitter';
        } else if (unitopIdName === 'wasteout') {
          unitType = 'WasteOut';
        } else if (unitopIdName === 'cartridge') {
          unitType = 'CF';
        } else if (unitopIdName === 'wex') {
          unitType = 'ERD';
        } else if (unitopIdName === 'peltonwheel') {
          unitType = 'PW';
        } else if (unitopIdName === 'TC') {
          unitType = 'TC';
        } else if (unitopIdName === 'clro') {
          unitType = 'CLRO';
        } else if (unitopIdName === 'boosterpump') {
          unitType = 'BoosterPump';
        } else if (unitopIdName === 'Wateranalysis') {
          unitType = 'WaterComp';
        } else if (unitopIdName === 'Argo') {
          unitType = 'Argo';
        }
        if (unitOpDetails_FeedStream[unitOpID[i]] === undefined)
          unitOpDetails_FeedStream[unitOpID[i]] = [];
        if (unitOpDetails_ROWasteStream[unitOpID[i]] === undefined)
          unitOpDetails_ROWasteStream[unitOpID[i]] = [];
        if (unitOpDetails_WasteStream[unitOpID[i]] === undefined)
          unitOpDetails_WasteStream[unitOpID[i]] = [];
        if (unitOpDetails_SplitStream[unitOpID[i]] === undefined)
          unitOpDetails_SplitStream[unitOpID[i]] = [];
        if (unitOpDetails_ElectrodeStream[unitOpID[i]] === undefined)
          unitOpDetails_ElectrodeStream[unitOpID[i]] = [];
        if (unitOpDetails_ConcStream[unitOpID[i]] === undefined)
          unitOpDetails_ConcStream[unitOpID[i]] = [];
        if (unitOpDetails_ProductStream[unitOpID[i]] === undefined)
          unitOpDetails_ProductStream[unitOpID[i]] = [];
        if (unitType === 'EDI') {
          unit_op_dict[unitOpName[unitOpID[i]]] = {
            'Unit Type': unitType,
            'Feed': unitOpDetails_FeedStream[unitOpID[i]],
            'Waste': unitOpDetails_WasteStream[unitOpID[i]],
            'Electrode_Bleed': unitOpDetails_ElectrodeStream[unitOpID[i]],
            'Conc_Bleed': unitOpDetails_ConcStream[unitOpID[i]],
            'Product': unitOpDetails_ProductStream[unitOpID[i]],
            'name': unitOpName[unitOpID[i]]
          };
        } else if (unitType === 'RO' || unitType === 'RO_HP' || unitType === 'CLRO' || unitType === 'NF' || unitType === 'NF_HP') {
          unit_op_dict[unitOpName[unitOpID[i]]] = {
            'Unit Type': unitType,
            'Feed': unitOpDetails_FeedStream[unitOpID[i]],
            'Waste': unitOpDetails_WasteStream[unitOpID[i]],
            'Split_flow': unitOpDetails_SplitStream[unitOpID[i]],
            'Product': unitOpDetails_ProductStream[unitOpID[i]],
            'name': unitOpName[unitOpID[i]]
          };
        } else if (unitType === 'ERD' || unitType === 'TC') {
          unit_op_dict[unitOpName[unitOpID[i]]] = {
            'Unit Type': unitType,
            'Feed': unitOpDetails_FeedStream[unitOpID[i]],
            'Waste': unitOpDetails_WasteStream[unitOpID[i]],
            'RO_Waste': unitOpDetails_ROWasteStream[unitOpID[i]],
            'Product': unitOpDetails_ProductStream[unitOpID[i]],
            'name': unitOpName[unitOpID[i]]
          };
        } else {
          unit_op_dict[unitOpName[unitOpID[i]]] = {
            'Unit Type': unitType,
            'Feed': unitOpDetails_FeedStream[unitOpID[i]],
            'Waste': unitOpDetails_WasteStream[unitOpID[i]],
            'Product': unitOpDetails_ProductStream[unitOpID[i]],
            'name': unitOpName[unitOpID[i]]
          };
        }
        delete unit_op_dict.null;
        // console.log('unit_op_dictc', unit_op_dict);
        const unit_op_dict_final = { unit_op_dict };
        const data = {
          unit_op_dict_final,
          stream_input_dict_final,
        };
        const roUnitOp = [];
        unitOpID.forEach((item) => {
          if (item.includes('ro_') || item.includes('roPump_') || item.includes('nf_') || item.includes('nfPump_')) {
            roUnitOp.push(unitOpName[item]);
          }
        });

        const flow_sheet_dict = findAllPath(data, stream_input_dict, roUnitOp);
        if (flow_sheet_dict && flow_sheet_dict.Type !== 'Brine Staged') {
          localStorage.setItem('flow_sheet_dict', JSON.stringify(flow_sheet_dict));
          // console.log('flow_sheet_dict', flow_sheet_dict);
        }
      }
    }
    if ((src.startsWith('roPump') && src.endsWith('d'))) {
      const connected = 'roWastage';
      localStorage.setItem('flow_sheet_dict_wastage', connected);
    }
    if (src.startsWith('nfPump') && src.endsWith('d')) {
      const connected = 'nfWastage';
      localStorage.setItem('flow_sheet_dict_nfwastage', connected);
    }
  }
}